import Link from "@tiptap/extension-link";
import Table from "@tiptap/extension-table";
import TableCell from "@tiptap/extension-table-cell";
import TableHeader from "@tiptap/extension-table-header";
import TableRow from "@tiptap/extension-table-row";
import StarterKit from "@tiptap/starter-kit";
import { Markdown } from "tiptap-markdown";

export function waveMarkdownExtensions() {
  return [
    StarterKit.configure({
      heading: { levels: [1, 2, 3] },
    }),
    Link.configure({
      openOnClick: true,
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer",
        class: "wave-inline-link",
      },
    }),
    Table.configure({ resizable: false }),
    TableRow,
    TableHeader,
    TableCell,
    Markdown.configure({
      html: false,
      transformPastedText: true,
      transformCopiedText: true,
    }),
  ];
}

export type WaveMarkdownEditorStorage = {
  markdown?: {
    getMarkdown: () => string;
  };
};

export function getMarkdownFromEditor(editor: { storage: unknown; getText: () => string }): string {
  const storage = editor.storage as WaveMarkdownEditorStorage;
  return storage.markdown?.getMarkdown() ?? editor.getText();
}
